import React from 'react';
import { useRouter } from 'next/router';
import { useSiteContext } from '../components/SiteContext';
import JobApplication from '../components/Jobs/Apply';
import withApollo from '../lib/apollo';
import withQuery from '../lib/withQuery';
import applyForJob from '../lib/queries/jobs/applyForJobQuery.graphql';
import getRedirectJobApply from '../lib/getRedirectJobApply';

const JobApplicationWithQuery = withQuery(JobApplication);

export const JobApplicationPage = () => {
  const { id } = useRouter().query;
  const { jobsLocale } = useSiteContext();

  return (
    <JobApplicationWithQuery
      query={applyForJob}
      variables={{ id: Number(id), locales: [jobsLocale] }}
      errorMessage="Error while loading job..."
    />
  );
};

JobApplicationPage.getInitialProps = getRedirectJobApply('job-apply');

export default withApollo(JobApplicationPage);
